export const AppID = 'ss';
export const BaseUrl = '/';
export const ApiUrl = '/api/';
